// Step builders reference their texts as `k.<key>` → 'tour:<page>.<key>' (src/locales/<lang>/tour.json).
// AppTour resolves the key with t(), so step texts follow language changes without per-language code.
export const tourKeys = page => new Proxy({}, { get: (_, key) => `tour:${page}.${String(key)}` })
